//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Afooter from '@/components/Afooter'
export default {
  name: 'mine',
  components: {
    Afooter,
  },
  data: function () {
    return {
      title: '我的',
      bannerH: 0,
      top: 0,
      dataList: [
        {
          type: '学习顾问' ,
          typeEn: 'xxgw' ,
          title: '请教',
          content: '你好，我是您的私人学习顾问，您可以问我关于语文、英语、数学、物理、地理、化学、历史、生物等各学科问题哦'
        },
        {
          type: '医疗顾问' ,
          typeEn: 'ylgw' ,
          title: '咨询',
          content: '您好，我是您的私人医疗顾问，您可以向我咨询任何医疗相关问题。'
        },
        {
          type: '法律顾问' ,
          typeEn: 'flgw' ,
          title: '咨询',
          content: '您好，我是您的法律顾问，我可以帮您解决任何法律问题。'
        },
        {
          type: '星象占卜' ,
          typeEn: 'xxzb' ,
          title: '分析',
          content: '您好，我是您的星象占卜师，我可以帮您分析星座运势。'
        },
        {
          type: '旅游出行' ,
          typeEn: 'lycx' ,
          title: '制定',
          content: '您好，您可以提供游玩地区，我将为您制定最佳游玩路线。'
        },
        {
          type: '语言翻译' ,
          typeEn: 'yyfy' ,
          title: '翻译',
          content: '您好，我是您的语言翻译秘书，您可以输入任一种语言的内容并说明翻译成的国家语言，我将为您实时翻译。'
        },
        {
          type: '美食探店' ,
          typeEn: 'mstd' ,
          title: '打卡',
          content: '您好，您可以提供想吃的美食或游玩地区，我将为您提供网红特色小吃详细地点和价格。'
        },
        {
          type: '私人厨房' ,
          typeEn: 'srcf' ,
          title: '制作',
          content: '您好，我是您的美食大厨，可以为您提供精致美食菜谱'
        },
        {
          type: '营销策划' ,
          typeEn: 'yxch' ,
          title: '策划',
          content: '您好，您可以提出您想要的方案，越详细越好。比如：帮我写一个有创意的艺术培训招生营销方案，且足够吸引学生和家长。'
        },
        {
          type: 'AI编程' ,
          typeEn: 'AIbc' ,
          title: '编写',
          content: '您好，我是您的IT工程师，您可以提出您的代码要求。比如使用python语句统计成绩，要求输入一批学生成绩，计算平均成绩，并统计不及格学生人数。'
        }
      ]

    }
  },
  filters: {
    formatDate (value, format) {
      if (!value) {
        return '--'
      }
      const d = new Date(value) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      const year = d.getFullYear()
      let month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1
      let day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
      let hours = d.getHours() < 10 ? '0' + d.getHours() : d.getHours()
      let min = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()
      let sec = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds()

      return format
        .replace('YYYY', year)
        .replace('MM', month)
        .replace('DD', day)
        .replace('HH', hours)
        .replace('mm', min)
        .replace('ss', sec)
    },
  },
  created () {
  },
  mounted () {
    this.$refs.bannerImg.onload = () => {
      this.bannerH = document.getElementById('banner').offsetHeight + 15
    }
  },
  activated () {
    // this.getUser()
    // this.getUserInfo()
    // this.getWalletBalance()
  },
  methods: {
    goChat (type) {
      //  this.$router.push({
      //   path: '/setting'
      // })
      this.$router.push({
        path: '/chat?type=' + encodeURIComponent(type)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/test.vue